import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiGatewayService } from './api-gateway.service';
import { State } from '../models/state.model';
import { Lookups } from '../models/lookups.model';
import { Country } from '../models/country.model';
import { Province } from '../models/province.model';
import { AdminAuthService } from './auth.service';
import { ApiGatewayModel } from 'src/app/models/api-gateway-model';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  lookups = new Lookups();
  lookupsSubject: BehaviorSubject<Lookups> = new BehaviorSubject(this.lookups);
  lookups$: Observable<any> = this.lookupsSubject;
  private storageSub = new Subject<string>();

  constructor(private apiService: ApiGatewayService, private authService: AdminAuthService) {
    this.GetLookups();
  }

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  public getLocationLookups() {
    let gatewayModel: ApiGatewayModel = {
      actionDescription: 'GetAdminCompanyLocationData',
      body: {},
    };

    // Check if we have this set of lookups in cache
    if (!this.lookups || !this.lookups.states || this.lookups.states.length <= 0) {
      this.apiService.SendRequest('', gatewayModel).subscribe((res) => {
        this.lookups.states = res[0].states as State[];
        this.lookups.countries = res[0].countries as Country[];
        this.lookups.provinces = res[0].provinces as Province[];
        localStorage.setItem('Lookups', JSON.stringify(this.lookups));
      });
    }
  }

  public GetLookups(): Lookups {
    var lookupsFromStorage = localStorage.getItem('Lookups') || '{}';
    this.lookups = JSON.parse(lookupsFromStorage) as Lookups;
    return this.lookups;
  }
}
